import Vue from "vue/dist/vue.esm.js";

import FGBreadHead from "./fastgo/FGBreadHead";
import FGDictRenderer from "./fastgo/FGDictRenderer";
import FGDictRendererCN from "./fastgo/FGDictRendererCN";
import FGDictSelect from "./fastgo/FGDictSelect";
import FGDataSelectForRegister from "./fastgo/FGDataSelectForRegister";
import FGDictSelectCN from "./fastgo/FGDictSelectCN";
import FGDataSelect from "./fastgo/FGDataSelect";
import FGCollapsiblePanel from "./fastgo/FGCollapsiblePanel";
import AttachUpload from "./admin/AttachUpload";
import AttachDownload from "./admin/AttachDownload";
import ActiveHistoryProcess from "./admin/ActiveHistoryProcess";
import OperLog from "./admin/OperLog";
import UploadButton from "./admin/UploadButton";
import UploadButtonRegister from "./admin/UploadButtonRegister";
import UploadImage from "./admin/UploadImage";
import AttachModalUpload from "./admin/AttachModalUpload";
import AttachModalUploadRegister from "./admin/AttachModalUploadRegister";
import AttachModalDownload from "./admin/AttachModalDownload";
import AttachUploadZJ from "./admin/AttachUploadZJ";

Vue.component("FGDataSelect", FGDataSelect);
Vue.component("FGDataSelectForRegister", FGDataSelectForRegister);
Vue.component("FGBreadHead", FGBreadHead);
Vue.component("FGDictRenderer", FGDictRenderer);
Vue.component("FGDictRendererCN", FGDictRendererCN);
Vue.component("FGDictSelect", FGDictSelect);
Vue.component("FGDictSelectCN", FGDictSelectCN);
Vue.component("FGCollapsiblePanel", FGCollapsiblePanel);
Vue.component("AttachUpload", AttachUpload);
Vue.component("AttachDownload", AttachDownload);
Vue.component("ActiveHistoryProcess", ActiveHistoryProcess);
Vue.component("OperLog", OperLog);
Vue.component("UploadButton", UploadButton);
Vue.component("UploadButtonRegister", UploadButtonRegister);
Vue.component("UploadImage", UploadImage);
Vue.component("AttachModalUpload", AttachModalUpload);
Vue.component("AttachModalUploadRegister", AttachModalUploadRegister);
Vue.component("AttachModalDownload", AttachModalDownload);
Vue.component("AttachUploadZJ", AttachUploadZJ);
